import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { backend } from '../../../components/apipath';

function Memberregister() {
    const [formData, setFormData] = useState({
        chinese_name: "",
        account: "",
        password: "",
        confirmPassword: "" 
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 表單驗證
        if (!formData.account || !formData.password || !formData.confirmPassword) {
            return Swal.fire({
                imageUrl: '/member_img/logo.svg',
                confirmButtonColor: '#224040',
                title: '糟糕！',
                color:"#224040",
                text: "資料填寫不完整",
            });
        }

        if (!validateEmail(formData.account)) {
            return Swal.fire({
                imageUrl: '/member_img/logo.svg',
                confirmButtonColor: '#224040',
                title: '糟糕！',
                color:"#224040",
                text: "電子郵件不符合格式",
            });
        }

        if (formData.password !== formData.confirmPassword) {
            return Swal.fire({
                imageUrl: '/member_img/logo.svg',
                confirmButtonColor: '#224040',
                title: '糟糕！',
                color:"#224040",
                text: "密碼與確認密碼不一致",
            });
        }

        try {
            const response = await axios.post(`${backend}join/register`, {
                chinese_name: formData.chinese_name,
                account: formData.account,
                password: formData.password
            });

            // console.log("後端回應:", response);

            if (response.data.code === "200") {
                Swal.fire({
                    imageUrl: '/member_img/logo.svg',
                    confirmButtonColor: '#224040',
                    color: "#224040",
                    text: "註冊成功",
                });
                navigate("/member/memberlogin");
                window.location.reload();
            } else if (response.data.code === "400") {
                Swal.fire({
                    imageUrl: '/member_img/logo.svg',
                    confirmButtonColor: '#224040',
                    title: '糟糕！',
                    color: "#224040",
                    text: "帳號已存在",
                });
            } else {
                Swal.fire({
                    imageUrl: '/member_img/logo.svg',
                    confirmButtonColor: '#224040',
                    title: '糟糕！',
                    color: "#224040",
                    text: response.data.message || "未知錯誤",
                });
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire({
                imageUrl: '/member_img/logo.svg',
                confirmButtonColor: '#224040',
                title: '糟糕！',
                color: "#224040",
                text: "網路錯誤或伺服器錯誤",
            });
        }
    };

    const validateEmail = (email) => {
        const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailReg.test(String(email).toLowerCase());
    };

    return (
        <form className="forms_form" onSubmit={handleSubmit}>
            <fieldset className="forms_fieldset">
                <div className="forms_field">
                    <input type="text" id="chinese_name" placeholder="Full Name" className="forms_field-input" value={formData.chinese_name} onChange={handleChange} required />
                </div>
                <div className="forms_field">
                    <input type="email" id="account" placeholder="Email" className="forms_field-input" value={formData.account} onChange={handleChange} required />
                </div>
                <div className="forms_field">
                    <input type="password" id="password" placeholder="Password" className="forms_field-input" value={formData.password} onChange={handleChange} required />
                </div>
                <div className="forms_field">
                    <input type="password" id="confirmPassword" placeholder="Confirm Password" className="forms_field-input" value={formData.confirmPassword} onChange={handleChange} required />
                </div>
            </fieldset>
            <div className="forms_buttons">
                <input type="submit" value="Sign up" className="forms_buttons-action"/>
            </div>
        </form>
    );
}

export default Memberregister;